import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const labelCenter = {
    id: "labelCenter",
    beforeDraw: (chart, args, options) => {
      if (!Array.isArray(options.labels)) {
        return console.error('"options.lables" must be array', options.lables);
      }
  
      const {
        ctx,
        chartArea: { width, height }
      } = chart;
      const context = ctx.canvas.getContext("2d");
      context.save();
  
      const labels = options.labels.slice();
      const totalFontSize = labels.reduce((x, y, index) => {
        let prevSize = x[index - 1] || 0;
        x.push(prevSize + y.font.size);
        return x;
      }, []);
      labels.forEach((label, index) => {
        let textPosition = totalFontSize[index] - label.font.size+10;
        const values = {
          text: label.text || "?",
          font: {
            size: label.font.size || 30,
            family: label.font.family || "sans-serif",
            color: label.font.color || "black",
            style: label.font.style || "normal",
            unit: label.font.unit || "px"
          }
        };
        switch (values.font.unit) {
          case "em":
            values.font.size = label.font.size * 0.05;
            textPosition *= 0.8;
            break;
          default:
            break;
        }
  
        context.font = `${values.font.style} ${values.font.size}${values.font.unit} ${values.font.family}`;
        context.textAlign = "center";
        context.fillStyle = values.font.color;
        context.fillText(values.text, width / 2, height / 2 + textPosition);
      });
      context.restore();
    }
  };

const HealthAgeAverageAge = (props) => {
  const graphcolors = [ '#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
  const GetColor = (score)=>{
    
    const vg = parseInt(score <=39 ? 3 : score<=69 ? 2 : score<=100 ? 1 : 0)
    return graphcolors[0]
  }

  const Color = GetColor(props.CurrentOWSValue)
    const data = {
  datasets: [
    {
      label: props.OWSText,
      data: [props.CurrentOWSValue, 100-props.CurrentOWSValue],
      backgroundColor: [
        Color,
        Color+"40"
      ],
      borderColor: [
        'rgba(255, 99, 132, 0)',
        'rgba(54, 162, 235, 0)',
      ],
      borderWidth: 0,
    },
  ],
    }
    const options = {
        responsive: true,
        cutout: '90%',
        animation:{
            animateRotate: true,
            render: false,
        },
        events: [],
        tooltips:{
            enabled: false
        },
        plugins: {
            legend: {
                display: false
            },
            labelCenter: {
                labels: [
                  {
                    text: Math.floor(props.CurrentOWSValue),
                    font: {
                      size: 3.25,
                      unit: "rem",
                      color: 'black',
                      style: "bold"
                    }
                  }
                ]
              }
            
        }
    }
    const plugins = [labelCenter]
    return <Doughnut data={data} options={options} plugins={plugins}/>
}

export default HealthAgeAverageAge